import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import { teal, lightBlue } from '@mui/material/colors';
import CardHeader from '@mui/material/CardHeader'
// import { useIdToken } from '../hooks/useLogin';
import CustomTable from '../components/chatbot/CustomTable';
import CopyToClipboard from '../utilities/CopyToClipboard';
import { selectDatachatbotResult } from '../store/features/chatbotSlice';
import TableDescription from '../components/chatbot/TableDescription';

const REFRESH_TOKEN_EVERY_X_MINUTES = 20 * 1000 * 60

export interface ChatResponseAnswer {
  response_data: {
    "data": any // ReportProps | string | number,
    "data_type": string,
    "data_unit": string,
    "machine_model": string,
    "machine_vin": string,
    "metric": string,
    "metric_type": string,
    "time": string,
    "company_name"?: string,
    "device_type"?: string
  },
  response_type: string
}

export interface ChatResultType {
  query: string,
  answer: ChatResponseAnswer[]
}

const DataPage = () => {
  const chatResults = useSelector(selectDatachatbotResult)
  // const { getToken } = useIdToken()

  // useEffect(() => {
  //   getToken()
  //   const timer = setInterval(async () => {
  //     await getToken()
  //   }, REFRESH_TOKEN_EVERY_X_MINUTES);

  //   return () => {
  //     clearInterval(timer);
  //   }
  // }, []);

  useEffect(() => {
    const chatContainer = document.getElementById('chat-container')
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight - chatContainer.clientHeight,
        behavior: 'smooth'
      })
    }
  }, [chatResults])

  return (
    <>
      <Grid container component={Paper} sx={{ backgroundColor: '#f5f5f0', color: '#fff' }}>
        <Grid id="chat-container" flex={1} item xs={12} sx={{ overflowY: 'auto', height: '80vh' }}>
          <Grid item
            xs={11}
            sx={{
              backgroundColor: '#f5f5f5',
              color: '#000',
              textAlign: 'left',
              height: '0px'
            }}>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: lightBlue['500'] }}>AI</Avatar>
              }
              title="Hi, this is DATA chatbot. What would you like to ask today?"
            />
          </Grid>
          {chatResults.map((e: any, index: number) => (
            <Grid container key={index}>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: teal[100] }}>H</Avatar>
                  }
                  title={e.query}
                />
              </Grid>
              <Grid
                item xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: lightBlue['500'] }}>AI</Avatar>
                  }
                />
                <Grid container key={index}
                  justifyContent="center"
                  alignItems="center">
                  <Grid item xs={11}
                    sx={{
                      backgroundColor: '#f5f5f5', //434654
                      color: '#000',
                      textAlign: 'left',
                      px: 1
                    }}>
                    <div id={index.toString()}>
                      {e.answer[0].response_data?.sql_explanation} <br /> <br />
                      {
                        (e.answer[0].response_type === 'text'
                        ) && <div dangerouslySetInnerHTML={{ __html: e.answer[0].response_data.data }}></div>
                      }

                      {
                        (e.answer[0].response_type === 'table'
                          && <CustomTable data={e.answer[0].response_data.data} />)
                      }
                      {
                        (e.answer[0].response_type === 'table'
                          && (<div style={{ paddingTop: '10px' }}> <TableDescription data={e.answer[0].response_data} /></div>
                            // <div style={{ paddingTop: '10px'}}>
                            //   <ul>
                            //     <li>Table Description: {e.answer[0].response_data?.tables_desc}</li>
                            //     <li>Query Description: {e.answer[0].response_data?.sql_explanation}</li>
                            //   </ul>
                            //   </div>
                          ))
                      }
                      <CopyToClipboard id={index.toString()} result={e} />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export default DataPage;